import {useEffect, useRef, useState} from 'react';
import clsx from 'clsx';
import gsap from 'gsap';

import styles from './styles.module.scss';
import {Add} from '../../assets';
import {list} from './data';

export const FAQ = () => {
  return (
    <div className={styles.frequently}>
      <h3 className={styles.title}>Frequently Asked Questions</h3>
      <h3 className={styles.titleMobile}>faq</h3>

      <p className={styles.subTitle}>You’ve got questions, we’ve got answers.</p>
      <div className={styles.frequentlyList}>
        {list.map((item) => {
          return <FAQItem key={item.question} question={item.question} answer={item.answer} />;
        })}
      </div>
    </div>
  );
};

const FAQItem = ({question, answer}) => {
  const refText = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (active) {
      gsap.to(refText.current, {
        padding: '10px 0px',
        height: '100%',
        duration: 0.6,
        ease: 'elastic.out(1,0.34)',
      });
      return;
    }
    gsap.to(refText.current, {
      height: 0,
      padding: '10px 0 0 0',
    });
  }, [active]);

  return (
    <div className={styles.frequentlyItem}>
      <div className={styles.frequentlyItemHeader} onClick={() => setActive((prev) => !prev)}>
        <Add
          className={clsx(styles.frequentlyItemIcon, {
            [styles.active]: active,
          })}
        />
        <h4 className={styles.frequentlyItemQuestion}>{question}</h4>
      </div>
      <div ref={refText} className={styles.frequentlyItemAnswer}>
        <p className={styles.frequentlyItemAnswerText}>{answer}</p>
      </div>
    </div>
  );
};
